import { createStore } from 'vuex'
import router from '@/router'

export default createStore({
  state: {
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    route: null,
    business: JSON.parse(localStorage.getItem('business') || 'null')
  },
  getters: {
    isAuthenticated: state => !!state.token && !!state.user,
    isLoggedIn: state => !!state.token && !!state.user,
    isMaster: state => state.user && state.user.role === 'master',
    business: state => state.business,
    user: state => state.user,
    authStatus: state => state.status
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    setUser (state, user) {
      state.user = user
    },
    setPath (state, route) {
      state.route = route
    },
    setBusiness (state, business) {
      state.business = business
    }
  },
  actions: {
    savePath ({ commit }, path) {
      commit('setPath', path)
      localStorage.setItem('route', path)
      router.push({ name: path })
    },
    saveBusiness ({ commit }, business) {
      commit('setBusiness', business)
      if (business) {
        const pathBusiness = 'dashboard'
        commit('setPath', pathBusiness)
        localStorage.setItem('route', pathBusiness)
        localStorage.setItem('business', JSON.stringify(business))
        router.push({ name: pathBusiness })
      }
    },
    saveUser ({ commit }, user) {
      commit('setUser', user)
      localStorage.setItem('user', JSON.stringify(user))
    },
    clearBusiness ({ commit }) {
      commit('setBusiness', null)
      localStorage.removeItem('business')
      const pathBusiness = 'business'
      commit('setPath', pathBusiness)
      localStorage.setItem('route', pathBusiness)
      router.push({ name: pathBusiness })
    },
    saveToken ({ commit }, token) {
      commit('setToken', token)
      localStorage.setItem('token', token)
      const initialRoute = 'dashboard'
      commit('setPath', initialRoute)
      router.push({ name: initialRoute })
    },
    autoLogin ({ commit }) {
      const token = localStorage.getItem('token')
      const currentRoute = localStorage.getItem('route')
      const user = JSON.parse(localStorage.getItem('user') || 'null')
      const business = JSON.parse(localStorage.getItem('business') || 'null')

      if (token) {
        commit('setToken', token)
        if (user) commit('setUser', user)
        if (business) commit('setBusiness', business)

        const routeToGo = currentRoute || 'dashboard'
        if (router.currentRoute.value.name !== routeToGo) {
          router.push({ name: routeToGo })
        }
      } else {
        if (router.currentRoute.value.name !== 'login') {
          router.push({ name: 'login' })
        }
      }
    },
    logout ({ commit }) {
      commit('setToken', null)
      commit('setUser', null)
      commit('setBusiness', null)

      localStorage.removeItem('token')
      localStorage.removeItem('route')
      localStorage.removeItem('business')
      localStorage.removeItem('user')

      router.push({ name: 'login' })
    }
  },
  modules: { }
})
